<template>
  <div>
    <Header />
    <div class="container">
      <el-row>
        <el-col :sm="24">
          <center>
            <el-button @click="regresar" type="primary" size="medium" icon="el-icon-back"
              style="margin-bottom: 10px">Regresar</el-button>
          </center>
        </el-col>
      </el-row>
      <hr />
      <br />
      <el-row :gutter="25">
        <el-col :sm="12">
          <el-row>
            <el-col :sm="24">
              <h2>{{ $t("Solicitud de creación de un nuevo inventario de riesgos y asignación de cuentas de acceso") }}
              </h2>
            </el-col>
            <el-col :sm="24">
              <el-alert title="Información" type="info" show-icon>
                <small>
                  En caso de necesitar crear un nuevo inventario de riesgos en plataforma, debe completar el siguiente
                  formulario a continuación; donde se solicitará la información para definir si es un inventario para
                  una
                  empresa colaboradora o un inventario de riesgo propio de una determinada área de las ASSETS de BHP. El
                  formulario será enviado a nuestro equipo de soporte para que proceder a su gestión.
                  Información a considerar:
                  <br><br>
                  Este formulario es únicamente para generar un nuevo servicio (contrato o subcontrato) e inventarios
                  propios de la compañía, en caso de que desee actualizar la información de un inventario de riesgos ya
                  existente en plataforma o requiere realizar cambios de usuarios esto debe ser canalizado directamente
                  con el equipo de soporte de la plataforma inventario de riesgos HSE Online BHP mediante los canales
                  disponibles en plataforma (correo, chat y contacto telefónico).
                </small>
              </el-alert>
              <br /><br />
            </el-col>
            <el-col :sm="24">
              <span style="font-size: 14px">Seleccione una faena</span><br />
              <el-select @change="getGerenciasGenerales" size="sm" style="width: 100%; margin-top: 5px" v-model="faena_id"
                placeholder="Seleccione una opción">
                <el-option v-for="(item, index) in faenas" :key="index" :label="item.nombre" :value="item._id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <br />
          <el-row>
            <el-col :sm="24">
              <span style="font-size: 14px">Seleccione tipo de contrato</span><br />
              <el-select @change="setTipo" size="sm" style="width: 100%; margin-top: 5px" v-model="tipo_contrato"
                placeholder="Seleccione una opción">
                <el-option v-for="(item, index) in tipos" :key="index" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <br>
          <el-row>
            <el-col :sm="24">
              <span style="font-size: 14px">Nombre del usuario que realiza la solicitud</span><br />
              <el-input style="width: 100%; margin-top: 5px" size="sm" v-model="form.creador"></el-input>
            </el-col>
          </el-row>
          <br>
          <el-row>
            <el-col :sm="24">
              <span style="font-size: 14px">Correo electrónico del usuario que realiza la solicitud</span><br />
              <el-input style="width: 100%; margin-top: 5px" size="sm" v-model="form.email_creador"></el-input>
            </el-col>
          </el-row>
          <br>
          <el-row>
            <el-col :sm="24">
              <span style="font-size: 14px">Teléfono del usuario que realiza la solicitud</span><br />
              <el-input style="width: 100%; margin-top: 5px" size="sm" v-model="form.creador_movil"></el-input>
            </el-col>
          </el-row>
          <br>
          <br /><br />
          <el-row v-if="tipo_contrato === 'Contratista'">
            <el-col :sm="24">
              <el-form label-position="left" v-model="form" status-icon label-width="250px">
                <b><span style="font-size: 14px">Información general</span></b>
                <br /><br /><br />
                <el-form-item label="Nombre de empresa">
                  <el-input size="sm" v-model="form.nombre_empresa"></el-input>
                </el-form-item>
                <el-form-item label="Rut de empresa">
                  <el-input size="sm" v-model="form.rut_empresa"></el-input>
                </el-form-item>
                <el-form-item label="N° de contrato">
                  <el-input size="sm" v-model="form.numero_contrato"></el-input>
                </el-form-item>
                <el-form-item label="Nombre del contrato">
                  <el-input size="sm" v-model="form.nombre_contrato"></el-input>
                </el-form-item>
                <el-form-item label="Alcance del contrato">
                  <el-input type="textarea" :rows="3" size="sm" v-model="form.alcance_contrato"></el-input>
                </el-form-item>
                <el-form-item label="Fecha de inicio">
                  <el-date-picker style="width: 350px" size="sm" v-model="form.fecha_inicio" type="date"
                    placeholder="Seleccione un día">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="Fecha de fin">
                  <el-date-picker style="width: 350px" size="sm" v-model="form.fecha_fin" type="date"
                    placeholder="Seleccione un día">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="Nombre contract owner BHP (SPA)">
                  <el-input size="sm" v-model="form.nombre_owner"></el-input>
                </el-form-item>
                <el-form-item label="Correo contract owner BHP (SPA)">
                  <el-input size="sm" v-model="form.email_owner"></el-input>
                </el-form-item>
                <el-form-item label="Gerencia General">
                  <el-select filterable @change="getGerencias" size="sm" style="width: 100%; margin-top: 5px"
                    v-model="form.gerencia_general" placeholder="Seleccione una opción">
                    <el-option v-for="(item, index) in gerencias_generales" :key="index" :label="item.nombre" :value="item._id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Gerencia" v-if="gerencias.length > 0 && form.gerencia_general !== ''">
                  <el-select filterable @change="getSuperintendencias" size="sm" style="width: 100%; margin-top: 5px"
                    v-model="form.gerencia" placeholder="Seleccione una opción">
                    <el-option v-for="(item, index) in gerencias" :key="index" :label="item.nombre" :value="item._id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Superintendencia" v-if="superintendencias.length > 0 && form.gerencia !== ''">
                  <el-select filterable size="sm"
                    style="width: 100%; margin-top: 5px" v-model="form.superintendencia"
                    placeholder="Seleccione una opción">
                    <el-option v-for="(item, index) in superintendencias" :key="index" :label="item.nombre"
                      :value="item._id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <br />
                <hr />
                <br />
                <b><span style="font-size: 14px">Coordinador - Esta será la persona encargada de crear el
                    inventario.</span></b><el-button @click="duplicarHSE1" style="margin-left: 20px" type="danger"
                  size="small">Duplicar</el-button>
                <br /><br /><br />
                <el-form-item label="Nombre">
                  <el-input size="sm" v-model="form.nombre_coordinador"></el-input>
                </el-form-item>
                <el-form-item label="Apellido paterno">
                  <el-input size="sm" v-model="form.apellido_paterno_coordinador"></el-input>
                </el-form-item>
                <el-form-item label="Apellido materno">
                  <el-input size="sm" v-model="form.apellido_materno_coordinador"></el-input>
                </el-form-item>
                <el-form-item label="Nombre de usuario">
                  <el-input size="sm" v-model="form.coordinador_rut"></el-input>
                </el-form-item>
                <el-form-item label="Correo electrónico">
                  <el-input size="sm" v-model="form.coordinador_correo"></el-input>
                </el-form-item>
                <el-form-item label="Cargo">
                  <el-input size="sm" v-model="form.coordinador_cargo"></el-input>
                </el-form-item>
                <el-form-item label="Celular">
                  <el-input size="sm" v-model="form.coordinador_celular"></el-input>
                </el-form-item>
                <br />
                <hr />
                <br />
                <b><span style="font-size: 14px">HSE Contratista 1 - Su tarea es aprobar el inventario.
                  </span></b><el-button @click="duplicarHSE2" style="margin-left: 20px" type="danger"
                  size="small">Duplicar</el-button>
                <br /><br /><br />
                <el-form-item label="Nombre">
                  <el-input size="sm" v-model="form.nombre_hse1"></el-input>
                </el-form-item>
                <el-form-item label="Apellido paterno">
                  <el-input size="sm" v-model="form.apellido_paterno_hse1"></el-input>
                </el-form-item>
                <el-form-item label="Apellido materno">
                  <el-input size="sm" v-model="form.apellido_materno_hse1"></el-input>
                </el-form-item>
                <el-form-item label="Nombre de usuario">
                  <el-input size="sm" v-model="form.hse1_rut"></el-input>
                </el-form-item>
                <el-form-item label="Correo electrónico">
                  <el-input size="sm" v-model="form.hse1_correo"></el-input>
                </el-form-item>
                <el-form-item label="Cargo">
                  <el-input size="sm" v-model="form.hse1_cargo"></el-input>
                </el-form-item>
                <el-form-item label="Celular">
                  <el-input size="sm" v-model="form.hse1_celular"></el-input>
                </el-form-item>
                <br />
                <hr />
                <br />
                <b><span style="font-size: 14px">HSE Contratista 2 - Su tarea es aprobar el inventario.
                  </span></b>
                <br /><br /><br />
                <el-form-item label="Nombre">
                  <el-input size="sm" v-model="form.nombre_hse2"></el-input>
                </el-form-item>
                <el-form-item label="Apellido paterno">
                  <el-input size="sm" v-model="form.apellido_paterno_hse2"></el-input>
                </el-form-item>
                <el-form-item label="Apellido materno">
                  <el-input size="sm" v-model="form.apellido_materno_hse2"></el-input>
                </el-form-item>
                <el-form-item label="Nombre de usuario">
                  <el-input size="sm" v-model="form.hse2_rut"></el-input>
                </el-form-item>
                <el-form-item label="Correo electrónico">
                  <el-input size="sm" v-model="form.hse2_correo"></el-input>
                </el-form-item>
                <el-form-item label="Cargo">
                  <el-input size="sm" v-model="form.hse2_cargo"></el-input>
                </el-form-item>
                <el-form-item label="Celular">
                  <el-input size="sm" v-model="form.hse2_celular"></el-input>
                </el-form-item>
                <br />
                <hr />
                <br />
                <b><span style="font-size: 14px">Administrador - No puede ser Coordinador y HSE (Su tarea es
                    aprobar el inventario).
                  </span></b>
                <br /><br /><br />
                <el-form-item label="Nombre">
                  <el-input size="sm" v-model="form.nombre_administrador2"></el-input>
                </el-form-item>
                <el-form-item label="Apellido paterno">
                  <el-input size="sm" v-model="form.apellido_paterno_administrador2"></el-input>
                </el-form-item>
                <el-form-item label="Apellido materno">
                  <el-input size="sm" v-model="form.apellido_materno_administrador2"></el-input>
                </el-form-item>
                <el-form-item label="Nombre de usuario">
                  <el-input size="sm" v-model="form.administrador_rut"></el-input>
                </el-form-item>
                <el-form-item label="Correo electrónico">
                  <el-input size="sm" v-model="form.administrador_correo"></el-input>
                </el-form-item>
                <el-form-item label="Cargo">
                  <el-input size="sm" v-model="form.administrador_cargo"></el-input>
                </el-form-item>
                <el-form-item label="Celular">
                  <el-input size="sm" v-model="form.administrador_celular"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button @click="continuar" type="primary">Enviar solicitud</el-button>
                  <el-button @click="regresar">Regresar</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <!-- PROPIO -->
          <el-row v-if="tipo_contrato === 'Propio'">
            <el-col :sm="24">
              <el-form label-position="left" v-model="form" status-icon label-width="200px">
                <b><span style="font-size: 14px">Información general</span></b>
                <br /><br /><br />
                <el-form-item label="Nombre del contrato">
                  <el-input size="sm" v-model="form.nombre_contrato"></el-input>
                </el-form-item>
                <el-form-item label="Gerencia General">
                  <el-select filterable @change="getGerencias" size="sm" style="width: 100%; margin-top: 5px"
                    v-model="form.gerencia_general" placeholder="Seleccione una opción">
                    <el-option v-for="(item, index) in gerencias_generales" :key="index" :label="item.nombre" :value="item._id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Gerencia" v-if="gerencias.length > 0 && form.gerencia_general !== ''">
                  <el-select filterable @change="getSuperintendencias" size="sm" style="width: 100%; margin-top: 5px"
                    v-model="form.gerencia" placeholder="Seleccione una opción">
                    <el-option v-for="(item, index) in gerencias" :key="index" :label="item.nombre" :value="item._id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Superintendencia" v-if="superintendencias.length > 0 && form.gerencia !== ''">
                  <el-select filterable size="sm"
                    style="width: 100%; margin-top: 5px" v-model="form.superintendencia"
                    placeholder="Seleccione una opción">
                    <el-option v-for="(item, index) in superintendencias" :key="index" :label="item.nombre"
                      :value="item._id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <br />
                <hr />
                <br />
                <b><span style="font-size: 14px">Coordinador - Esta será la persona encargada de crear el
                    inventario en el sistema.</span></b>
                <br /><br /><br />
                <el-form-item label="Nombre">
                  <el-input size="sm" v-model="form.nombre_coordinador"></el-input>
                </el-form-item>
                <el-form-item label="Apellido paterno">
                  <el-input size="sm" v-model="form.apellido_paterno_coordinador"></el-input>
                </el-form-item>
                <el-form-item label="Apellido materno">
                  <el-input size="sm" v-model="form.apellido_materno_coordinador"></el-input>
                </el-form-item>
                <el-form-item label="Nombre de usuario">
                  <el-input size="sm" v-model="form.coordinador_rut"></el-input>
                </el-form-item>
                <el-form-item label="Correo electrónico">
                  <el-input size="sm" v-model="form.coordinador_correo"></el-input>
                </el-form-item>
                <el-form-item label="Cargo">
                  <el-input size="sm" v-model="form.coordinador_cargo"></el-input>
                </el-form-item>
                <el-form-item label="Celular">
                  <el-input size="sm" v-model="form.coordinador_celular"></el-input>
                </el-form-item>
                <br />
                <hr />
                <br />
                <b><span style="font-size: 14px">Especialista de salud 1 - Su tarea es aprobar el
                    inventario.
                  </span></b><el-button @click="duplicarSalud" style="margin-left: 20px" type="danger"
                  size="small">Duplicar</el-button>
                <br /><br /><br />
                <el-form-item label="Nombre">
                  <el-input size="sm" v-model="form.nombre_salud"></el-input>
                </el-form-item>
                <el-form-item label="Apellido paterno">
                  <el-input size="sm" v-model="form.apellido_paterno_salud"></el-input>
                </el-form-item>
                <el-form-item label="Apellido materno">
                  <el-input size="sm" v-model="form.apellido_materno_salud"></el-input>
                </el-form-item>
                <el-form-item label="Nombre de usuario">
                  <el-input size="sm" v-model="form.salud_rut"></el-input>
                </el-form-item>
                <el-form-item label="Correo electrónico">
                  <el-input size="sm" v-model="form.salud_correo"></el-input>
                </el-form-item>
                <el-form-item label="Cargo">
                  <el-input size="sm" v-model="form.salud_cargo"></el-input>
                </el-form-item>
                <el-form-item label="Celular">
                  <el-input size="sm" v-model="form.salud_celular"></el-input>
                </el-form-item>
                <br />
                <hr />
                <br />
                <b><span style="font-size: 14px">Especialista de salud 2 - Su tarea es aprobar el
                    inventario.
                  </span></b>
                <br /><br /><br />
                <el-form-item label="Nombre">
                  <el-input size="sm" v-model="form.nombre_salud2"></el-input>
                </el-form-item>
                <el-form-item label="Apellido paterno">
                  <el-input size="sm" v-model="form.apellido_paterno_salud2"></el-input>
                </el-form-item>
                <el-form-item label="Apellido materno">
                  <el-input size="sm" v-model="form.apellido_materno_salud2"></el-input>
                </el-form-item>
                <el-form-item label="Nombre de usuario">
                  <el-input size="sm" v-model="form.salud2_rut"></el-input>
                </el-form-item>
                <el-form-item label="Correo electrónico">
                  <el-input size="sm" v-model="form.salud2_correo"></el-input>
                </el-form-item>
                <el-form-item label="Cargo">
                  <el-input size="sm" v-model="form.salud2_cargo"></el-input>
                </el-form-item>
                <el-form-item label="Celular">
                  <el-input size="sm" v-model="form.salud2_celular"></el-input>
                </el-form-item>
                <br />
                <hr />
                <br />
                <b><span style="font-size: 14px">Especialista de seguridad 1 - Su tarea es aprobar el
                    inventario.
                  </span></b><el-button @click="duplicarSeguridad" style="margin-left: 20px" type="danger"
                  size="small">Duplicar</el-button>
                <br /><br /><br />
                <el-form-item label="Nombre">
                  <el-input size="sm" v-model="form.nombre_seguridad"></el-input>
                </el-form-item>
                <el-form-item label="Apellido paterno">
                  <el-input size="sm" v-model="form.apellido_paterno_seguridad"></el-input>
                </el-form-item>
                <el-form-item label="Apellido materno">
                  <el-input size="sm" v-model="form.apellido_materno_seguridad"></el-input>
                </el-form-item>
                <el-form-item label="Nombre de usuario">
                  <el-input size="sm" v-model="form.seguridad_rut"></el-input>
                </el-form-item>
                <el-form-item label="Correo electrónico">
                  <el-input size="sm" v-model="form.seguridad_correo"></el-input>
                </el-form-item>
                <el-form-item label="Cargo">
                  <el-input size="sm" v-model="form.seguridad_cargo"></el-input>
                </el-form-item>
                <el-form-item label="Celular">
                  <el-input size="sm" v-model="form.seguridad_celular"></el-input>
                </el-form-item>
                <br />
                <hr />
                <br />
                <b><span style="font-size: 14px">Especialista de seguridad 2 - Su tarea es aprobar el
                    inventario.
                  </span></b>
                <br /><br /><br />
                <el-form-item label="Nombre">
                  <el-input size="sm" v-model="form.nombre_seguridad2"></el-input>
                </el-form-item>
                <el-form-item label="Apellido paterno">
                  <el-input size="sm" v-model="form.apellido_paterno_seguridad2"></el-input>
                </el-form-item>
                <el-form-item label="Apellido materno">
                  <el-input size="sm" v-model="form.apellido_materno_seguridad2"></el-input>
                </el-form-item>
                <el-form-item label="Nombre de usuario">
                  <el-input size="sm" v-model="form.seguridad2_rut"></el-input>
                </el-form-item>
                <el-form-item label="Correo electrónico">
                  <el-input size="sm" v-model="form.seguridad2_correo"></el-input>
                </el-form-item>
                <el-form-item label="Cargo">
                  <el-input size="sm" v-model="form.seguridad2_cargo"></el-input>
                </el-form-item>
                <el-form-item label="Celular">
                  <el-input size="sm" v-model="form.seguridad2_celular"></el-input>
                </el-form-item>
                <br />
                <hr />
                <br />
                <b><span style="font-size: 14px">Especialista de medioambiente 1 - Su tarea es aprobar el
                    inventario.
                  </span></b><el-button @click="duplicarMedioambiente" style="margin-left: 20px" type="danger"
                  size="small">Duplicar</el-button>
                <br /><br /><br />
                <el-form-item label="Nombre">
                  <el-input size="sm" v-model="form.nombre_medioambiente"></el-input>
                </el-form-item>
                <el-form-item label="Apellido paterno">
                  <el-input size="sm" v-model="form.apellido_paterno_medioambiente"></el-input>
                </el-form-item>
                <el-form-item label="Apellido materno">
                  <el-input size="sm" v-model="form.apellido_materno_medioambiente"></el-input>
                </el-form-item>
                <el-form-item label="Nombre de usuario">
                  <el-input size="sm" v-model="form.medioambiente_rut"></el-input>
                </el-form-item>
                <el-form-item label="Correo electrónico">
                  <el-input size="sm" v-model="form.medioambiente_correo"></el-input>
                </el-form-item>
                <el-form-item label="Cargo">
                  <el-input size="sm" v-model="form.medioambiente_cargo"></el-input>
                </el-form-item>
                <el-form-item label="Celular">
                  <el-input size="sm" v-model="form.medioambiente_celular"></el-input>
                </el-form-item>
                <br />
                <hr />
                <br />
                <b><span style="font-size: 14px">Especialista de medioambiente 2 - Su tarea es aprobar el
                    inventario.
                  </span></b>
                <br /><br /><br />
                <el-form-item label="Nombre">
                  <el-input size="sm" v-model="form.nombre_medioambiente2"></el-input>
                </el-form-item>
                <el-form-item label="Apellido paterno">
                  <el-input size="sm" v-model="form.apellido_paterno_medioambiente2"></el-input>
                </el-form-item>
                <el-form-item label="Apellido materno">
                  <el-input size="sm" v-model="form.apellido_materno_medioambiente2"></el-input>
                </el-form-item>
                <el-form-item label="Nombre de usuario">
                  <el-input size="sm" v-model="form.medioambiente2_rut"></el-input>
                </el-form-item>
                <el-form-item label="Correo electrónico">
                  <el-input size="sm" v-model="form.medioambiente2_correo"></el-input>
                </el-form-item>
                <el-form-item label="Cargo">
                  <el-input size="sm" v-model="form.medioambiente2_cargo"></el-input>
                </el-form-item>
                <el-form-item label="Celular">
                  <el-input size="sm" v-model="form.medioambiente2_celular"></el-input>
                </el-form-item>
                <br />
                <hr />
                <br />
                <b><span style="font-size: 14px">Especialista de Riesgo - Su tarea es aprobar el inventario.
                  </span></b>
                <br /><br /><br />
                <el-form-item label="Nombre">
                  <el-input size="sm" v-model="form.nombre_especialista_riesgo"></el-input>
                </el-form-item>
                <el-form-item label="Apellido paterno">
                  <el-input size="sm" v-model="form.apellido_paterno_especialista_riesgo"></el-input>
                </el-form-item>
                <el-form-item label="Apellido materno">
                  <el-input size="sm" v-model="form.apellido_materno_especialista_riesgo"></el-input>
                </el-form-item>
                <el-form-item label="Nombre de usuario">
                  <el-input size="sm" v-model="form.especialista_riesgo_rut"></el-input>
                </el-form-item>
                <el-form-item label="Correo electrónico">
                  <el-input size="sm" v-model="form.especialista_riesgo_correo"></el-input>
                </el-form-item>
                <el-form-item label="Cargo">
                  <el-input size="sm" v-model="form.especialista_riesgo_cargo"></el-input>
                </el-form-item>
                <el-form-item label="Celular">
                  <el-input size="sm" v-model="form.especialista_riesgo_celular"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button @click="continuar" type="primary">Enviar solicitud</el-button>
                  <el-button @click="regresar">Regresar</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-col>
        <el-col :sm="12">
          <h2>{{ $t("Consulte el estado de su solicitud") }}</h2>
          <el-alert title="Información" type="success"
            description="Para consultar el estado de avance debe ingresar el código de seguimiento que fue entregado al momento de realizar la solicitud."
            show-icon>
          </el-alert>
          <br /><br />
          <el-form ref="formConsulta" label-position="left" :model="consulta" label-width="170px">
            <el-form-item label="Código de seguimiento" prop="codigo_seguimiento" :rules="[
              {
                required: true,
                message: 'Código de seguimiento es requerido',
              },
            ]">
              <el-input v-model="consulta.codigo_seguimiento" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="medium" type="primary" @click="submitForm('formConsulta')">Consultar</el-button>
            </el-form-item>
          </el-form>
          <el-table row-class-name="rowClassTablaPloma" cell-class-name="cellClassTablaPloma"
            header-cell-class-name="header-cell-class-table-gray" v-if="solicitud" :data="solicitud.seguimiento"
            style="width: 100%">
            <el-table-column prop="fecha" label="Fecha" width="300">
            </el-table-column>
            <el-table-column prop="estado" label="Estado" width="170">
              <template slot-scope="scope">
                <el-tag size="medium" :type="scope.row.estado === 'Solicitud ingresada'
                  ? 'info'
                  : scope.row.estado === 'Solicitud en trámite'
                    ? 'warning'
                    : scope.row.estado === 'Solicitud finalizada'
                      ? 'success'
                      : ''
                  ">{{ scope.row.estado }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="comentarios" label="Comentario">

              <template slot-scope="scope">
                <el-tag type="danger" size="small" v-if="scope.row.comentarios === ''">Sin comentarios</el-tag>
                <span v-else>{{ scope.row.comentarios }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-step-wizard";
import "vue-step-wizard/dist/vue-step-wizard.css";
import { Circle9 } from "vue-loading-spinner";
import Header from "../components/Header.vue";
import axios from "axios";
import uuid from "uuid/v4";

export default {
  name: "wizard",
  components: {
    Header,
    Circle9,
    FormWizard,
    TabContent,
  },
  data() {
    return {
      gerencias_generales: [],
      solicitud: null,
      consulta: {
        codigo_seguimiento: "",
      },
      form: {
        creador: "",
        email_creador: "",
        creador_movil: "",
        nombre_empresa: "",
        rut_empresa: "",
        numero_contrato: "",
        nombre_contrato: "",
        alcance_contrato: "",
        fecha_inicio: "",
        fecha_fin: "",
        nombre_owner: "",
        email_owner: "",
        gerencia: "",
        gerencia_general: "",
        superintendencia: "",
        nombre_coordinador: "",
        apellido_materno_coordinador: "",
        apellido_paterno_coordinador: "",
        coordinador_rut: "",
        coordinador_correo: "",
        coordinador_cargo: "",
        coordinador_celular: "",
        nombre_hse1: "",
        apellido_materno_hse1: "",
        apellido_paterno_hse1: "",
        hse1_rut: "",
        hse1_correo: "",
        hse1_cargo: "",
        hse1_celular: "",
        nombre_hse2: "",
        apellido_materno_hse2: "",
        apellido_paterno_hse2: "",
        hse2_rut: "",
        hse2_correo: "",
        hse2_cargo: "",
        hse2_celular: "",
        nombre_administrador: "",
        apellido_materno_administrador: "",
        apellido_paterno_administrador: "",
        administrador_rut: "",
        administrador_correo: "",
        administrador_cargo: "",
        administrador_celular: "",
        nombre_salud: "",
        apellido_materno_salud: "",
        apellido_paterno_salud: "",
        salud_rut: "",
        salud_correo: "",
        salud_cargo: "",
        salud_celular: "",
        nombre_salud2: "",
        apellido_materno_salud2: "",
        apellido_paterno_salud2: "",
        salud2_rut: "",
        salud2_correo: "",
        salud2_cargo: "",
        salud2_celular: "",
        nombre_seguridad: "",
        apellido_materno_seguridad: "",
        apellido_paterno_seguridad: "",
        seguridad_rut: "",
        seguridad_correo: "",
        seguridad_cargo: "",
        seguridad_celular: "",
        nombre_seguridad2: "",
        apellido_materno_seguridad2: "",
        apellido_paterno_seguridad2: "",
        seguridad2_rut: "",
        seguridad2_correo: "",
        seguridad2_cargo: "",
        seguridad2_celular: "",
        nombre_medioambiente: "",
        apellido_materno_medioambiente: "",
        apellido_paterno_medioambiente: "",
        medioambiente_rut: "",
        medioambiente_correo: "",
        medioambiente_cargo: "",
        medioambiente_celular: "",
        nombre_medioambiente2: "",
        apellido_materno_medioambiente2: "",
        apellido_paterno_medioambiente2: "",
        medioambiente2_rut: "",
        medioambiente2_correo: "",
        medioambiente2_cargo: "",
        medioambiente2_celular: "",
        nombre_especialista_riesgo: "",
        apellido_materno_especialista_riesgo: "",
        apellido_paterno_especialista_riesgo: "",
        especialista_riesgo_rut: "",
        especialista_riesgo_correo: "",
        especialista_riesgo_cargo: "",
        especialista_riesgo_celular: "",
      },
      loading: false,
      gerencias: [],
      superintendencias: [],
      tipo_contrato: "",
      faena_id: "",
      faenas: [],
      tipos: [
        {
          value: "Contratista",
          label: "Contrato Contratista",
        },
        {
          value: "Propio",
          label: "Contrato Propio",
        },
      ],
    };
  },
  watch: {},
  computed: {},
  async created() {
    await this.getFaenas();
  },
  methods: {
    async getGerenciasGenerales() {
      this.form.gerencia_general = "";
      this.form.gerencia = "";
      this.form.superintendencia = "";
      let response = await axios.get(
        `/data-science/getGerenciasGenerales/${this.faena_id}`
      );
      this.gerencias_generales = response.data;
    },
    async getGerencias() {
      this.form.gerencia = "";
      this.form.superintendencia = "";
      let response = await axios.get(
        `/data-science/getGerencias/${this.faena_id}/${this.form.gerencia_general}`
      );
      this.gerencias = response.data;
    },
    async getSuperintendencias() {
      this.form.superintendencia = "";
      let response = await axios.get(
        `/data-science/getSuperintendencias/${this.form.gerencia}`
      );
      this.superintendencias = response.data;
    },
    duplicarSalud() {
      this.form.nombre_salud2 = this.form.nombre_salud;
      this.form.apellido_materno_salud2 = this.form.apellido_materno_salud;
      this.form.apellido_paterno_salud2 = this.form.apellido_paterno_salud;
      this.form.salud2_rut = this.form.salud_rut;
      this.form.salud2_correo = this.form.salud_correo;
      this.form.salud2_cargo = this.form.salud_cargo;
      this.form.salud2_celular = this.form.salud_celular;
    },
    duplicarSeguridad() {
      this.form.nombre_seguridad2 = this.form.nombre_seguridad;
      this.form.apellido_materno_seguridad2 =
        this.form.apellido_materno_seguridad;
      this.form.apellido_paterno_seguridad2 =
        this.form.apellido_paterno_seguridad;
      this.form.seguridad2_rut = this.form.seguridad_rut;
      this.form.seguridad2_correo = this.form.seguridad_correo;
      this.form.seguridad2_cargo = this.form.seguridad_cargo;
      this.form.seguridad2_celular = this.form.seguridad_celular;
    },
    duplicarMedioambiente() {
      this.form.nombre_medioambiente2 = this.form.nombre_medioambiente;
      this.form.apellido_materno_medioambiente2 =
        this.form.apellido_materno_medioambiente;
      this.form.apellido_paterno_medioambiente2 =
        this.form.apellido_paterno_medioambiente;
      this.form.medioambiente2_rut = this.form.medioambiente_rut;
      this.form.medioambiente2_correo = this.form.medioambiente_correo;
      this.form.medioambiente2_cargo = this.form.medioambiente_cargo;
      this.form.medioambiente2_celular = this.form.medioambiente_celular;
    },
    duplicarHSE1() {
      this.form.nombre_hse1 = this.form.nombre_coordinador;
      this.form.apellido_materno_hse1 = this.form.apellido_materno_coordinador;
      this.form.apellido_paterno_hse1 = this.form.apellido_paterno_coordinador;
      this.form.hse1_rut = this.form.coordinador_rut;
      this.form.hse1_correo = this.form.coordinador_correo;
      this.form.hse1_cargo = this.form.coordinador_cargo;
      this.form.hse1_celular = this.form.coordinador_celular;
    },
    duplicarHSE2() {
      this.form.nombre_hse2 = this.form.nombre_hse1;
      this.form.apellido_materno_hse2 = this.form.apellido_materno_hse1;
      this.form.apellido_paterno_hse2 = this.form.apellido_paterno_hse1;
      this.form.hse2_rut = this.form.hse1_rut;
      this.form.hse2_correo = this.form.hse1_correo;
      this.form.hse2_cargo = this.form.hse1_cargo;
      this.form.hse2_celular = this.form.hse1_celular;
    },
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let response = await axios.get(
            `/contratos/getSolicitudId/${this.consulta.codigo_seguimiento}`
          );
          if (response.data.length > 0) {
            this.solicitud = response.data[0];
          } else {
            this.solicitud = null;
            this.$alert(
              "No ha encontrado información asociada al código de seguimiento ingresado",
              "Información importante",
              {
                type: "info",
                confirmButtonText: "Aceptar",
                callback: (action) => { },
              }
            );
          }
        } else {
          return false;
        }
      });
    },
    async continuar() {
      if (this.tipo_contrato === "Propio") {
        if (
          this.form.creador === "" ||
          this.form.email_creador === "" ||
          this.form.creador_movil === "" ||
          this.form.nombre_contrato === "" ||
          this.form.gerencia_general === "" ||
          this.form.nombre_coordinador === "" ||
          this.form.apellido_paterno_coordinador === "" ||
          this.form.apellido_materno_coordinador === "" ||
          this.form.coordinador_rut === "" ||
          this.form.coordinador_correo === "" ||
          this.form.coordinador_cargo === "" ||
          this.form.coordinador_celular === "" ||
          this.form.nombre_salud === "" ||
          this.form.apellido_paterno_salud === "" ||
          this.form.apellido_materno_salud === "" ||
          this.form.salud_rut === "" ||
          this.form.salud_correo === "" ||
          this.form.salud_cargo === "" ||
          this.form.salud_celular === "" ||
          this.form.nombre_salud2 === "" ||
          this.form.apellido_paterno_salud2 === "" ||
          this.form.apellido_materno_salud2 === "" ||
          this.form.salud2_rut === "" ||
          this.form.salud2_correo === "" ||
          this.form.salud2_cargo === "" ||
          this.form.salud2_celular === "" ||
          this.form.nombre_seguridad === "" ||
          this.form.apellido_paterno_seguridad === "" ||
          this.form.apellido_materno_seguridad === "" ||
          this.form.seguridad_rut === "" ||
          this.form.seguridad_correo === "" ||
          this.form.seguridad_cargo === "" ||
          this.form.seguridad_celular === "" ||
          this.form.nombre_seguridad2 === "" ||
          this.form.apellido_paterno_seguridad2 === "" ||
          this.form.apellido_materno_seguridad2 === "" ||
          this.form.seguridad2_rut === "" ||
          this.form.seguridad2_correo === "" ||
          this.form.seguridad2_cargo === "" ||
          this.form.seguridad2_celular === "" ||
          this.form.nombre_medioambiente === "" ||
          this.form.apellido_paterno_medioambiente === "" ||
          this.form.apellido_materno_medioambiente === "" ||
          this.form.medioambiente_rut === "" ||
          this.form.medioambiente_correo === "" ||
          this.form.medioambiente_cargo === "" ||
          this.form.medioambiente_celular === "" ||
          this.form.nombre_medioambiente2 === "" ||
          this.form.apellido_paterno_medioambiente2 === "" ||
          this.form.apellido_materno_medioambiente2 === "" ||
          this.form.medioambiente2_rut === "" ||
          this.form.medioambiente2_correo === "" ||
          this.form.medioambiente2_cargo === "" ||
          this.form.medioambiente2_celular === "" ||
          this.form.nombre_especialista_riesgo === "" ||
          this.form.apellido_paterno_especialista_riesgo === "" ||
          this.form.apellido_materno_especialista_riesgo === "" ||
          this.form.especialista_riesgo_rut === "" ||
          this.form.especialista_riesgo_correo === "" ||
          this.form.especialista_riesgo_cargo === "" ||
          this.form.especialista_riesgo_celular === "" ||
          (this.gerencias.length > 0 && this.form.gerencia === "") || 
          (this.superintendencias.length > 0 && this.form.superintendencia === "")
        ) {
          this.$alert(
            "Para continuar debes completar todos los datos solicitados.",
            "Atención",
            {
              type: "warning",
              confirmButtonText: "Aceptar",
              callback: (action) => { },
            }
          );
          return false;
        }
      }
      if (this.tipo_contrato === "Contratista") {
        if (
          this.form.creador === "" ||
          this.form.email_creador === "" ||
          this.form.creador_movil === "" ||
          this.form.nombre_empresa === "" ||
          this.form.rut_empresa === "" ||
          this.form.numero_contrato === "" ||
          this.form.nombre_contrato === "" ||
          this.form.alcance_contrato === "" ||
          this.form.fecha_inicio === "" ||
          this.form.fecha_fin === "" ||
          this.form.nombre_owner === "" ||
          this.form.email_owner === "" ||
          this.form.gerencia_general === "" ||
          this.form.nombre_coordinador === "" ||
          this.form.apellido_paterno_coordinador === "" ||
          this.form.apellido_materno_coordinador === "" ||
          this.form.coordinador_rut === "" ||
          this.form.coordinador_correo === "" ||
          this.form.coordinador_cargo === "" ||
          this.form.coordinador_celular === "" ||
          this.form.nombre_hse1 === "" ||
          this.form.apellido_paterno_hse1 === "" ||
          this.form.apellido_materno_hse1 === "" ||
          this.form.hse1_rut === "" ||
          this.form.hse1_correo === "" ||
          this.form.hse1_cargo === "" ||
          this.form.hse1_celular === "" ||
          this.form.nombre_hse2 === "" ||
          this.form.apellido_paterno_hse2 === "" ||
          this.form.apellido_materno_hse2 === "" ||
          this.form.hse2_rut === "" ||
          this.form.hse2_correo === "" ||
          this.form.hse2_cargo === "" ||
          this.form.hse2_celular === "" ||
          this.form.nombre_administrador2 === "" ||
          this.form.apellido_paterno_administrador2 === "" ||
          this.form.apellido_materno_administrador2 === "" ||
          this.form.administrador_rut === "" ||
          this.form.administrador_correo === "" ||
          this.form.administrador_cargo === "" ||
          this.form.administrador_celular === "" ||
          (this.gerencias.length > 0 && this.form.gerencia === "") || 
          (this.superintendencias.length > 0 && this.form.superintendencia === "")
        ) {
          this.$alert(
            "Para continuar debes completar todos los datos solicitados.",
            "Atención",
            {
              type: "warning",
              confirmButtonText: "Aceptar",
              callback: (action) => { },
            }
          );
          return false;
        }
      }

      if (this.form.gerencia !== "" && this.form.superintendencia === "" && this.superintendencias.length > 0) {
        this.$alert(
          "Para continuar debes completar todos los datos solicitados.",
          "Atención",
          {
            type: "warning",
            confirmButtonText: "Aceptar",
            callback: (action) => { },
          }
        );
        return false;
      }

      if (this.tipo_contrato === "") {
        this.$alert(
          "Para continuar debes completar todos los datos solicitados.",
          "Atención",
          {
            type: "warning",
            confirmButtonText: "Aceptar",
            callback: (action) => { },
          }
        );
        return false;
      }

      if (this.faena_id === "") {
        this.$alert(
          "Para continuar debes completar todos los datos solicitados.",
          "Atención",
          {
            type: "warning",
            confirmButtonText: "Aceptar",
            callback: (action) => { },
          }
        );
        return false;
      }

      this.form["faena_id"] = this.faena_id;
      this.form["tipo_contrato"] = this.tipo_contrato;

      const response = await axios.post(
        `/contratos/crear-solicitud`,
        this.form
      );

      if (response.data.success === true) {
        this.$alert(response.data.message, "Información importante", {
          type: "success",
          confirmButtonText: "Aceptar",
          callback: (action) => { },
        });
        this.resetear();
      } else {
        this.$alert(response.data.message, "Información importante", {
          type: "error",
          confirmButtonText: "Aceptar",
          callback: (action) => { },
        });
      }
    },
    regresar() {
      this.resetear();
      this.$router.push("/");
    },
    setTipo() {
      this.form = {
        nombre_empresa: "",
        rut_empresa: "",
        numero_contrato: "",
        nombre_contrato: "",
        alcance_contrato: "",
        fecha_inicio: "",
        fecha_fin: "",
        nombre_owner: "",
        email_owner: "",
        gerencia: "",
        superintendencia: "",
        nombre_coordinador: "",
        apellido_materno_coordinador: "",
        apellido_paterno_coordinador: "",
        coordinador_rut: "",
        coordinador_correo: "",
        coordinador_cargo: "",
        coordinador_celular: "",
        nombre_hse1: "",
        apellido_materno_hse1: "",
        apellido_paterno_hse1: "",
        hse1_rut: "",
        hse1_correo: "",
        hse1_cargo: "",
        hse1_celular: "",
        nombre_hse2: "",
        apellido_materno_hse2: "",
        apellido_paterno_hse2: "",
        hse2_rut: "",
        hse2_correo: "",
        hse2_cargo: "",
        hse2_celular: "",
        nombre_administrador: "",
        apellido_materno_administrador: "",
        apellido_paterno_administrador: "",
        administrador_rut: "",
        administrador_correo: "",
        administrador_cargo: "",
        administrador_celular: "",
        nombre_salud: "",
        apellido_materno_salud: "",
        apellido_paterno_salud: "",
        salud_rut: "",
        salud_correo: "",
        salud_cargo: "",
        salud_celular: "",
        nombre_salud2: "",
        apellido_materno_salud2: "",
        apellido_paterno_salud2: "",
        salud2_rut: "",
        salud2_correo: "",
        salud2_cargo: "",
        salud2_celular: "",
        nombre_seguridad: "",
        apellido_materno_seguridad: "",
        apellido_paterno_seguridad: "",
        seguridad_rut: "",
        seguridad_correo: "",
        seguridad_cargo: "",
        seguridad_celular: "",
        nombre_seguridad2: "",
        apellido_materno_seguridad2: "",
        apellido_paterno_seguridad2: "",
        seguridad2_rut: "",
        seguridad2_correo: "",
        seguridad2_cargo: "",
        seguridad2_celular: "",
        nombre_medioambiente: "",
        apellido_materno_medioambiente: "",
        apellido_paterno_medioambiente: "",
        medioambiente_rut: "",
        medioambiente_correo: "",
        medioambiente_cargo: "",
        medioambiente_celular: "",
        nombre_medioambiente2: "",
        apellido_materno_medioambiente2: "",
        apellido_paterno_medioambiente2: "",
        medioambiente2_rut: "",
        medioambiente2_correo: "",
        medioambiente2_cargo: "",
        medioambiente2_celular: "",
        nombre_especialista_riesgo: "",
        apellido_materno_especialista_riesgo: "",
        apellido_paterno_especialista_riesgo: "",
        especialista_riesgo_rut: "",
        especialista_riesgo_correo: "",
        especialista_riesgo_cargo: "",
        especialista_riesgo_celular: "",
      };
    },
    resetear() {
      this.form = {
        creador: "",
        email_creador: "",
        creador_movil: "",
        nombre_empresa: "",
        rut_empresa: "",
        numero_contrato: "",
        nombre_contrato: "",
        alcance_contrato: "",
        fecha_inicio: "",
        fecha_fin: "",
        nombre_owner: "",
        email_owner: "",
        gerencia: "",
        superintendencia: "",
        nombre_coordinador: "",
        apellido_materno_coordinador: "",
        apellido_paterno_coordinador: "",
        coordinador_rut: "",
        coordinador_correo: "",
        coordinador_cargo: "",
        coordinador_celular: "",
        nombre_hse1: "",
        apellido_materno_hse1: "",
        apellido_paterno_hse1: "",
        hse1_rut: "",
        hse1_correo: "",
        hse1_cargo: "",
        hse1_celular: "",
        nombre_hse2: "",
        apellido_materno_hse2: "",
        apellido_paterno_hse2: "",
        hse2_rut: "",
        hse2_correo: "",
        hse2_cargo: "",
        hse2_celular: "",
        nombre_administrador: "",
        apellido_materno_administrador: "",
        apellido_paterno_administrador: "",
        administrador_rut: "",
        administrador_correo: "",
        administrador_cargo: "",
        administrador_celular: "",
        nombre_salud: "",
        apellido_materno_salud: "",
        apellido_paterno_salud: "",
        salud_rut: "",
        salud_correo: "",
        salud_cargo: "",
        salud_celular: "",
        nombre_salud2: "",
        apellido_materno_salud2: "",
        apellido_paterno_salud2: "",
        salud2_rut: "",
        salud2_correo: "",
        salud2_cargo: "",
        salud2_celular: "",
        nombre_seguridad: "",
        apellido_materno_seguridad: "",
        apellido_paterno_seguridad: "",
        seguridad_rut: "",
        seguridad_correo: "",
        seguridad_cargo: "",
        seguridad_celular: "",
        nombre_seguridad2: "",
        apellido_materno_seguridad2: "",
        apellido_paterno_seguridad2: "",
        seguridad2_rut: "",
        seguridad2_correo: "",
        seguridad2_cargo: "",
        seguridad2_celular: "",
        nombre_medioambiente: "",
        apellido_materno_medioambiente: "",
        apellido_paterno_medioambiente: "",
        medioambiente_rut: "",
        medioambiente_correo: "",
        medioambiente_cargo: "",
        medioambiente_celular: "",
        nombre_medioambiente2: "",
        apellido_materno_medioambiente2: "",
        apellido_paterno_medioambiente2: "",
        medioambiente2_rut: "",
        medioambiente2_correo: "",
        medioambiente2_cargo: "",
        medioambiente2_celular: "",
        nombre_especialista_riesgo: "",
        apellido_materno_especialista_riesgo: "",
        apellido_paterno_especialista_riesgo: "",
        especialista_riesgo_rut: "",
        especialista_riesgo_correo: "",
        especialista_riesgo_cargo: "",
        especialista_riesgo_celular: "",
      };
      this.faena_id = "";
      this.tipo_contrato = "";
    },
    async getFaenas() {
      let response = await axios.get(`/data-science/faenas`);
      this.faenas = response.data;
    },
  },
};
</script>

<style scoped>
.intermitente {
  box-shadow: 0px 0px 20px;
  animation: infinite resplandorAnimation 2s;
}

@keyframes resplandorAnimation {

  0%,
  100% {
    box-shadow: 0px 0px 10px red;
  }

  50% {
    box-shadow: 0px 0px 0px red;
  }
}
</style>
